import { SearchIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
} from '@/shared/components/ui/empty'

export function SalesFactorsImpactEmptyState() {
	const { t } = useTranslation()

	return (
		<Empty>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<SearchIcon />
				</EmptyMedia>
				<EmptyDescription>{t('no_data')}</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
